<template>
  <div class="h-100 d-flex flex-column flex-full-height">
    <b-navbar id="navigation-bar" class="top-nav-bar bg-navbar" toggleable="lg">
      <b-navbar-brand :to="{ name: 'dashboard' }">
        <img class="logo-main logo-nav-bar" src="@assets/MeDaPro_logo.svg" />
      </b-navbar-brand>
      <b-navbar-nav class="navbar-nav-search">
        <b-nav-form>
          <simple-search ref="simpleSearch" class="navbar-nav-simple-search" />
        </b-nav-form>
      </b-navbar-nav>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <!-- Right aligned sub menu items -->
      <b-navbar-nav class="ml-auto">
        <SaveState></SaveState>
        <b-nav-text v-on-click-outside="hideSettingsMenu">
          <b-avatar
            square
            :src="avatarImage"
            :class="{ 'no-image': !avatarImage }"
            :text="avatarText"
            button
            @click.prevent="showSettingsMenu = !showSettingsMenu"
            data-cy="app-settings-btn" />
          <application-settings v-show="showSettingsMenu" @close="showSettingsMenu = false" />
        </b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <div class="wrapper">
      <basic-layout-sidebar></basic-layout-sidebar>
      <div class="content-container">
        <context-menubar></context-menubar>

        <div class="content-inner-container" data-cy="main-content-container">
          <div id="app" class="home">
            <router-view ref="routerView" />
          </div>
        </div>
      </div>
    </div>
    <signal-r-notifier></signal-r-notifier>
  </div>
</template>

<script setup lang="ts">
import ContextMenubar from "@common/components/MenuBar/ContextMenuBar.vue";
import BasicLayoutSidebar from "@common/components/ModuleSidebar.vue";
import ApplicationSettings from "@common/components/OptionsMenus/ApplicationSettings.vue";
import SaveState from "@common/components/SaveState.vue";
import SimpleSearch from "@common/components/SimpleSearch.vue";
import { useUser } from "@common/composable/useRootStore";
import SignalRNotifier from "@common/views/SignalRNotifier.vue";
import { getInitials } from "@util/user";
import { computed, inject, onBeforeUnmount, onMounted, ref } from "vue";
import { useState } from "vuex-composition-helpers";
import { RootState } from "@medapro-types/common/rootstate";

const { user } = useUser();
const { jwt } = useState<RootState>(["jwt"]);

const $startSignalR = inject<(token: string) => void>("$startSignalR");
const $stopSignalR = inject<() => void>("$stopSignalR");

const showSettingsMenu = ref(false);

const avatarText = computed(() => {
  return getInitials(user.value.username);
});

const avatarImage = computed(() => {
  if (user.value.image) {
    return "data:image/png;base64," + user.value.image;
  } else {
    return null;
  }
});

// Methods
const hideSettingsMenu = () => {
  showSettingsMenu.value = false;
};

onMounted(() => {
  if ($startSignalR) $startSignalR(jwt.value.token);
});

onBeforeUnmount(() => {
  if ($stopSignalR) $stopSignalR();
});
</script>
